import { getStatusId } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useInsertEvents } from './_requests/saveEvents'
import { useModalData } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditServiceOrderForm = () => {
  const { t } = useTranslation()
  const { ids, statusName, onSuccess } = useModalData() || {}

  const [onSubmit, { loading, error }] = useInsertEvents(onSuccess)
  const status = !!getStatusId(statusName)
    ? { id: getStatusId(statusName), name: statusName, label: t(`status.${statusName}`) }
    : undefined

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={{ serviceOrderIds: ids, status }}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditServiceOrderForm
